export const DEFAULT_PER_PAGE_APPOINTMENTS = 50;

export const GET_PATIENTS = 'admin/get_patients';
export const GET_PATIENT_BY_ID = 'admin/get_patient_by_id';
